import styles from './PrivacyPolicy.module.css'

export function PrivacyPolicy() {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Política de Privacidad</h1>
            <div className={styles.content}>
                <p className={styles.updated}>Última actualización: Marzo 2026</p>

                <section className={styles.section}>
                    <h2>1. Información que Recopilamos</h2>
                    <p>En Imprime Digital, recopilamos la siguiente información cuando utilizas nuestros servicios:</p>
                    <ul>
                        <li><strong>Datos de cuenta:</strong> nombre, correo electrónico, contraseña encriptada.</li>
                        <li><strong>Datos de perfil:</strong> nombre de empresa, RUC/DNI, dirección de envío.</li>
                        <li><strong>Datos de uso:</strong> diseños creados, historial de pedidos, preferencias.</li>
                        <li><strong>Datos técnicos:</strong> dirección IP, tipo de navegador, dispositivo utilizado.</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2>2. Uso de la Información</h2>
                    <p>Utilizamos tu información para:</p>
                    <ul>
                        <li>Proporcionar y mejorar nuestros servicios de diseño e impresión.</li>
                        <li>Procesar y gestionar tus pedidos de impresión.</li>
                        <li>Enviar notificaciones sobre el estado de tus pedidos.</li>
                        <li>Mejorar la experiencia del usuario y funcionalidad de la plataforma.</li>
                        <li>Proteger la seguridad de tu cuenta.</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2>3. Almacenamiento y Seguridad</h2>
                    <p>Tus datos se almacenan de forma segura utilizando encriptación estándar de la industria. Los diseños y archivos se almacenan en Google Cloud Storage con acceso restringido. Las contraseñas se almacenan con hash y nunca en texto plano.</p>
                </section>

                <section className={styles.section}>
                    <h2>4. Compartición de Datos</h2>
                    <p>No vendemos ni compartimos tu información personal con terceros, excepto:</p>
                    <ul>
                        <li>Con proveedores de impresión para cumplir tus pedidos.</li>
                        <li>Con servicios de envío para la entrega de tus productos.</li>
                        <li>Cuando sea requerido por ley o autoridades competentes.</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2>5. Tus Derechos</h2>
                    <p>De acuerdo con la Ley N° 29733 (Ley de Protección de Datos Personales del Perú), tienes derecho a:</p>
                    <ul>
                        <li>Acceder a tus datos personales.</li>
                        <li>Rectificar datos incorrectos o incompletos.</li>
                        <li>Cancelar o solicitar la eliminación de tus datos.</li>
                        <li>Oponerte al tratamiento de tus datos.</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2>6. Cookies</h2>
                    <p>Utilizamos cookies esenciales para el funcionamiento del sitio y tokens JWT para la autenticación. No utilizamos cookies de seguimiento de terceros con fines publicitarios.</p>
                </section>

                <section className={styles.section}>
                    <h2>7. Contacto</h2>
                    <p>Para consultas sobre privacidad, contáctanos en: info@qolca.org</p>
                </section>
            </div>
        </div>
    )
}
